
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download-mobile-app",
      function () {
        return require("private-next-pages/download-mobile-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/download-mobile-app"])
      });
    }
  